// @TODO rename to PlanType and move to computers shared
export enum PlanTypes {
  NA = 0,
  Plan = 1,
  RestorePlan = 2,
  ExchangePlan = 3,
  DataBasePlan = 4,
  RestoreDataBasePlan = 5,
  BareMetalPlan = 6,
  RestoreBareMetalPlan = 7,
  RestoreSystemState = 8,
  RestoreExchangePlan = 9,
  RestoreDatabaseFilesPlan = 10,
  BackupVMware = 11,
  RestoreVMware = 12,
  BackupHyperV = 13,
  RestoreHyperV = 14,
  ConsistencyCheck = 15,
  BackupDiskImagePlan = 16,
  RestoreDiskImagePlan = 17,
  BackupSystemState = 18,
  CloudVMBackupEC2Plan = 19,
  CloudVMRestoreEC2Plan = 20,
  RestoreVMwareToCustom = 21,
  RestoreHyperVToCustom = 22,

  BackupProxmox = 23,
  RestoreProxmox = 24,

  InstantRestoreHyperV = 25,
  InstantRestoreProxmox = 26,
  InstantRestoreMSP360LDR = 27
}

export enum PlanVMNewTypesDisplay {
  'VMware restore plan' = PlanTypes.RestoreVMwareToCustom,
  'Hyper-V restore plan' = PlanTypes.RestoreHyperVToCustom
}

export enum PlanTypesDisplay {
  'Exchange backup plan' = PlanTypes.ExchangePlan,
  'Restore Exchange plan' = PlanTypes.RestoreExchangePlan,
  'VMware backup plan' = PlanTypes.BackupVMware,
  'VMware restore plan' = PlanTypes.RestoreVMware,
  'Hyper-V backup plan' = PlanTypes.BackupHyperV,
  'Hyper-V restore plan' = PlanTypes.RestoreHyperV,
  'Consistency Check plan' = PlanTypes.ConsistencyCheck,
  'Image-based backup plan' = PlanTypes.BackupDiskImagePlan,
  'Files backup plan' = PlanTypes.Plan,
  'Files restore plan' = PlanTypes.RestorePlan,
  'Image-based restore plan' = PlanTypes.RestoreDiskImagePlan,
  'EC2 backup plan' = PlanTypes.CloudVMBackupEC2Plan,
  'EC2 restore plan' = PlanTypes.CloudVMRestoreEC2Plan,
  'MS SQL backup plan' = PlanTypes.DataBasePlan,
  'MS SQL files restore plan' = PlanTypes.RestoreDatabaseFilesPlan,
  'MS SQL database restore plan' = PlanTypes.RestoreDataBasePlan,
  'Backup system state' = PlanTypes.BackupSystemState,
  'Restore system state' = PlanTypes.RestoreSystemState,
  'Bare Metal plan' = PlanTypes.BareMetalPlan,
  'Restore Bare Metal plan' = PlanTypes.RestoreBareMetalPlan,
  'Cloud VM backup EC2 plan' = PlanTypes.CloudVMBackupEC2Plan,
  'Cloud VM restore EC2 plan' = PlanTypes.CloudVMRestoreEC2Plan,
  'Proxmox backup plan' = PlanTypes.BackupProxmox,
  'Proxmox restore plan' = PlanTypes.RestoreProxmox,
  'Unknown' = 0
}

export enum UnableToCreateCBFPlanTypes {
  RestorePlan = PlanTypes.RestorePlan,
  BareMetalPlan = PlanTypes.BareMetalPlan,
  RestoreBareMetalPlan = PlanTypes.RestoreBareMetalPlan,
  RestoreVMware = PlanTypes.RestoreVMware,
  RestoreHyperV = PlanTypes.RestoreHyperV,
  RestoreDiskImagePlan = PlanTypes.RestoreDiskImagePlan,
  BackupSystemState = PlanTypes.BackupSystemState
}

export enum OldPagePlanTypes {
  ExchangePlan = PlanTypes.ExchangePlan,
  RestoreSystemState = PlanTypes.RestoreSystemState,
  RestoreExchangePlan = PlanTypes.RestoreExchangePlan,
  BackupSystemState = PlanTypes.BackupSystemState,
  CloudVMRestoreEC2Plan = PlanTypes.CloudVMRestoreEC2Plan
}

export enum ImagesOrPlanTypes {
  Plan = PlanTypes.Plan,
  RestorePlan = PlanTypes.RestorePlan,
  BackupDiskImagePlan = PlanTypes.BackupDiskImagePlan,
  RestoreDiskImagePlan = PlanTypes.RestoreDiskImagePlan
}

export enum VMPlanTypes {
  BackupVMware = PlanTypes.BackupVMware,
  RestoreVMware = PlanTypes.RestoreVMware,
  BackupHyperV = PlanTypes.BackupHyperV,
  RestoreHyperV = PlanTypes.RestoreHyperV
}

export enum LastInOrderPlanTypes {
  ConsistencyCheck = PlanTypes.ConsistencyCheck,
  RestoreSystemState = PlanTypes.RestoreSystemState,
  BackupSystemState = PlanTypes.BackupSystemState
}

export enum PlanCreateCommands {
  'newexch' = PlanTypes.ExchangePlan,
  'newrestore' = PlanTypes.RestorePlan,
  'newconsistencycheck' = PlanTypes.ConsistencyCheck,
  'newvmwarerestore' = PlanTypes.RestoreVMware,
  'newhypervbackup' = PlanTypes.BackupHyperV,
  'newhypervrestore' = PlanTypes.RestoreHyperV,
  'newrestoresystemstate' = PlanTypes.RestoreSystemState,
  'newrestoresql' = PlanTypes.RestoreDataBasePlan,
  'newfilesqlrestore' = PlanTypes.RestoreDatabaseFilesPlan
}

export enum PlanFormatTypes {
  CBF = 0,
  NBF = 1
}

export enum PlanFormatTypeNames {
  LBF = 'Legacy Backup Format',
  NBF = 'New Backup Format'
}

export enum PlanFormatTypeShortNames {
  LBF = 'LBF',
  NBF = 'NBF'
}

export const PlanFormatAdapter: { planFormat: PlanFormatTypes; shortName: PlanFormatTypeShortNames; fullName: PlanFormatTypeNames }[] = [
  { planFormat: PlanFormatTypes.CBF, shortName: PlanFormatTypeShortNames.LBF, fullName: PlanFormatTypeNames.LBF },
  { planFormat: PlanFormatTypes.NBF, shortName: PlanFormatTypeShortNames.NBF, fullName: PlanFormatTypeNames.NBF }
];

export enum PlanMode {
  create = 0,
  edit = 1
}

export type ComputerContentRequestItem = {
  deleted: boolean;
  displayName: string;
  modifyDateUTC: string;
  originalSize: number;
  path: string;
  type: number;
};
export type ComputerContentRequestData = { data: { items: ComputerContentRequestItem[]; totalCount: number; count: number } };
